import React from 'react';

export const ArrowRight = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      role="presentation"
      viewBox="0 0 44 45"
      {...props}
    >
      <g data-name="Group 28" fill="none">
        <path
          data-name="Rectangle 47"
          style={{
            isolation: "isolate",
          }}
          opacity={0.25}
          d="M0 0h44v45H0z"
        />
        <path
          data-name="Path 4"
          d="M18.87 17.24L24.59 23l-5.72 5.72"
          stroke="#26375f"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
        />
      </g>
    </svg>
  );
};
